import type { FC } from 'react';
import { lazy } from 'react';
import type { CmNetworkPointRequest } from 'src/apis/capacity-management/use-cm-network-point';
import { useInternalBookings } from 'src/apis/capacity-management/use-internal-bookings';
import { useTitle } from 'src/hooks/use-title';

const Page = lazy(() => import('./page'));

type Props = {
  cmNetworkPoint: CmNetworkPointRequest;
};

const AddInternalBooking: FC<Props> = ({ cmNetworkPoint }) => {
  const internalBookings = useInternalBookings({ cmNetworkPoint });

  useTitle('Add Internal Booking');

  return (
    <Page cmNetworkPoint={cmNetworkPoint} internalBookings={internalBookings} />
  );
};

export default AddInternalBooking;
